import { Save, Shaders, ToolEvents } from "@ortho-next/nextray-core";
import { BufferGeometry, Mesh, ShaderMaterial, ShapeGeometry } from "three";

export class CroppedPlane extends Mesh<BufferGeometry, ShaderMaterial, ToolEvents> {
  @Save("attributes.position", "attributes.normal", "attributes.uv", "index")
  public declare geometry: ShapeGeometry; //override

  public onAfterRestore = () => {
    this.geometry.computeBoundingSphere();
  }

  constructor(planeMaterial: ShaderMaterial) {
    super(new BufferGeometry(), new ShaderMaterial({
      vertexShader: Shaders.planeVertexShader,
      fragmentShader: Shaders.croppedPlaneFragmentShader,
      uniforms: {
        brightness: planeMaterial.uniforms['brightness'],
        contrast: planeMaterial.uniforms['contrast'],
        hFlip: planeMaterial.uniforms['hFlip'],
        vFlip: planeMaterial.uniforms['vFlip'],
        map: planeMaterial.uniforms['map']
      }
    }));
    this.name = "CroppedPlane";
    this.isDraggable = true;
  }

  public setGeometry(geometry: ShapeGeometry) {
    this.geometry.dispose();
    this.geometry = geometry;
  }
}
